import { CalendarClock } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { DropCountdown } from "@/components/DropCountdown";
import { getNextDrop, getFollowingDrop } from "@/data/drops";

export const DropSection = () => {
  const drop = getNextDrop();
  const after = getFollowingDrop();
  if (!drop) return null;

  return (
    <section className="py-16 md:py-24 bg-beet relative overflow-hidden" data-testid="navratri-drop-section">
      <div
        className="absolute inset-0 opacity-[0.08]"
        style={{ backgroundImage: "radial-gradient(circle at 15% 20%, #C6A052 0%, transparent 45%), radial-gradient(circle at 85% 80%, #DE8A5C 0%, transparent 45%)" }}
        aria-hidden="true"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <Reveal className="lg:col-span-7">
            <p className="font-mono text-xs tracking-[0.25em] uppercase text-turmeric font-semibold mb-4">
              Limited Edition — {drop.dateLabel}
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white font-semibold leading-tight mb-5">
              {drop.name}
            </h2>
            <p className="text-base leading-relaxed text-white/70 max-w-lg mb-8">{drop.tagline}</p>
            <DropCountdown />
            {after && (
              <p
                data-testid="next-drop-note"
                className="mt-6 inline-flex items-center gap-2 text-xs font-mono text-white/50 border border-white/15 rounded-full px-4 py-2"
              >
                <CalendarClock size={13} className="text-turmeric" />
                Up next: {after.name} — {after.dateLabel}
              </p>
            )}
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="bg-white/[0.07] backdrop-blur-sm border border-white/15 rounded-3xl p-6 md:p-7">
              <p className="font-mono text-xs tracking-[0.25em] uppercase text-turmeric font-semibold mb-5">
                On the drop menu
              </p>
              <ul className="space-y-4">
                {drop.menu.map((m, i) => (
                  <li key={m.n} data-testid={`drop-menu-item-${i + 1}`} className="flex gap-4 items-baseline">
                    <span className="font-mono text-turmeric text-sm font-semibold shrink-0">{String(i + 1).padStart(2, "0")}</span>
                    <div>
                      <p className="text-white font-semibold text-sm">{m.n}</p>
                      <p className="text-white/50 text-xs mt-0.5">{m.d}</p>
                    </div>
                  </li>
                ))}
              </ul>
              <p className="mt-6 text-xs font-mono text-white/40 border-t border-white/10 pt-4">
                Delhi NCR & Bengaluru only · quantities capped daily
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
